import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { Link, Heading } from '@printdeal/ui-library';

import { FormattedMessage, useIntl } from 'react-intl';
import {
  dispatchDataLayerOrderOverviewInteraction,
} from '../../../../helpers/dataLayerHelpers/OrderOverviewDataLayerHelper';
// @ts-expect-error
import { messages } from '../../translations/orders';
import OrderSearchAndResult from './OrderSearchAndResult';
import Breadcrumb from '../../../Breadcrumb';
import Head from '../../../PrivateHead';
import PaymentAlert from './PaymentAlert';

const OrderListPage = () => {
  const intl = useIntl();

  return (
    <div className="data-sentry-block">
      <Head title={intl.formatMessage(messages.orderTitle)} />

      <Breadcrumb className="pd-mb-4">
        <Breadcrumb.Item to="..">
          <FormattedMessage id="account.index.title" defaultMessage="My account" />
        </Breadcrumb.Item>
        <Breadcrumb.Item isCurrentPage>
          <FormattedMessage id="account.orders.title" defaultMessage="Order title" />
        </Breadcrumb.Item>
      </Breadcrumb>

      <PaymentAlert />

      <Heading className="pd-mb-5">
        <FormattedMessage id="account.orders.title" defaultMessage="Order title" />
      </Heading>

      <OrderSearchAndResult />

      <Link
        as={GatsbyLink}
        to=".."
        variant="secondary"
        className="pd-mt-4"
        onClick={() => dispatchDataLayerOrderOverviewInteraction('click_my_account_link')}
        iconBefore="chevron-left"
      >
        <FormattedMessage id="account.linkToAccount" defaultMessage="Link to account" />
      </Link>
    </div>
  );
};

export default OrderListPage;
